import React, { Fragment, useContext, useState } from "react";
import styled from "styled-components";
import { Layer } from "../../components";
import { AppContext, paymentCfg } from "../../components/AppProvider";
import DefaultContainer from "../../components/UI/Container/DefaultContainer";
import HeaderNavigate from "../../components/UI/Header/HeaderNavigate";
import LabelButton from "../../components/UI/Label/LabelButton";
import ToastMsg from "../../components/UI/Layer/ToastMsg/ToastMsg";
import ListPayment from "../../components/UI/List/ListPayment";
import { PostApi1973 } from "../../modules/network/padoPost";
import { payment } from "../../modules/payments/payments";
import { _O } from "../../modules/utils";
import { IC, ICON_RED_MINUS_SRC } from "../../resources/Assets";
import { CardIconImg } from "../../resources/CardIcon";
import CardEmpty from "./CardEmpty";

const CardList = props => {
  const { setPageType, setMoveUrl, cardList, getMyCardList } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [cardTemp, setCardTemp] = useState(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const [viewMsgLayer, setViewMsgLayer] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState();

  const REACT_APP_MALL_ID = paymentCfg.batchMallId;

  const postUrl = `${cfg.url}app/pg/payment?appUrl=${encodeURIComponent(
    location.origin + cfg.nftfReturnUrl
  )}&userToken=${userinfo.userToken}`;

  const webpayParams = {
    mallId: REACT_APP_MALL_ID,
    payMethodTypeCode: "81",
    currency: "00",
    amount: 0,
    clientTypeCode: "00",
    returnUrl: postUrl,
    shopOrderNo: userinfo.userToken,
    deviceTypeCode: "mobile",
    orderInfo: { goodsName: "비대면진료비" },
    payMethodInfo: {
      billKeyMethodInfo: {
        certType: "0",
      },
    },
  };

  const messageLayerData = {
    delete: {
      headerIcon: "",
      title: "카드 정보를 삭제하시겠어요?",
      desc: ["카드 삭제시 입력하신 정보가 모두 사라집니다"],
      ps: "",
      button: [
        {
          severity: "light",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "아니오",
        },
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => deleteCard(),
          text: "네",
        },
      ],
    },
  };

  const cardSelectEvent = (data, idx) => {
    if (data.errChkYn === "N") {
      // setCardInfo(data);
      setCardTemp(data);
      setActiveIdx(idx);
    } else {
      alert("사용이 불가한 카드입니다.");
    }
  };

  const deleteCard = () => {
    PostApi1973(userinfo, cfg, phonecfg, deleteTarget)
      .then(res => {
        // if (cardList.length === 1) {
        //   setCardInfo(null);
        //   setCardTemp(null);
        // }
        getMyCardList();
        setViewMsgLayer(false);
        // setActiveIdx(0);
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <Fragment>
      <DefaultContainer>
        <HeaderNavigate
          leftIcon={{
            imgSrc: IC.etc.ICON_CHEVRON_LEFT,
            action: () => _O.OpenMenu("/mp"),
          }}
          headerTitle="결제수단 관리"
        />

        <ContentsBody>
          <ContentBody>
            <ContentText>
              {cardList && cardList.length > 0 ? (
                <Fragment>
                  {cardList.map((data, i) => (
                    <ListPayment
                      key={"listPayments" + i}
                      data={{
                        Active: false,
                        Disable: data.errChkYn === "Y" ? true : false,
                        Header: {
                          H_Title: {
                            action: () => cardSelectEvent(data, i),
                            L_Icon: {
                              img: CardIconImg({
                                cardInfo: {
                                  cardCd: data.cardCd,
                                },
                              }),
                            },

                            H_Body: {
                              H_Body_Title: data.cardNm,
                              H_Body_Subs: [
                                {
                                  status: "default",
                                  text: data.cardNo,
                                },
                                data.errChkYn === "Y" && {
                                  status: "error",
                                  text: "결제실패",
                                },
                              ],
                            },
                          },

                          R_Icon: {
                            img: ICON_RED_MINUS_SRC,
                            action: () => {
                              setViewMsgLayer(true);
                              setDeleteTarget(data.seqNo);
                            },
                          },
                        },

                        Body: "",
                      }}
                    />
                  ))}
                </Fragment>
              ) : (
                // <Fragment>
                //   <ContentImage src={IC.card.ICON_CARD_GRAY} />
                //   <TextTitle>등록된 카드가 없어요</TextTitle>
                //   <TextDesc>
                //     결제수단 추가를 통해 카드를 등록하고 <br /> 접수를 진행해
                //     주세요
                //   </TextDesc>
                //   </Fragment>

                <CardEmpty />
              )}
            </ContentText>
            <LabelButton
              htmlFor={""}
              severity="light"
              disable="on"
              L_ICON={IC.etc.ICON_GRAY_PLUS}
              // clickEvent={() => setPageType("add")}>
              clickEvent={() =>
                payment(
                  userinfo,
                  cfg,
                  phonecfg,
                  setMoveUrl,
                  setPageType,
                  webpayParams
                )
              }>
              결제수단 추가
            </LabelButton>
          </ContentBody>
        </ContentsBody>
      </DefaultContainer>
      {viewMsgLayer && (
        <Layer
          headerIcon={messageLayerData.delete.headerIcon}
          title={messageLayerData.delete.title}
          desc={messageLayerData.delete.desc}
          ps={messageLayerData.delete.ps}
          button={messageLayerData.delete.button}
        />
      )}
    </Fragment>
  );
};

const ContentsBody = styled.div`
  width: 100vw;
  height: calc(100vh - 57px);
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  gap: 24px;

  /* background-color: black; */
`;

const ContentBody = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  padding: 40px 20px 24px;
`;

const ContentText = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 0;
`;

const ContentImage = styled.img`
  width: 64px;
  height: 64px;
  flex-grow: 0;
  padding: 11.6px 5.3px 11px 5.3px;
`;

const TextTitle = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: center;
  color: #333;
`;

const TextDesc = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: center;
  color: #888;
`;

export default CardList;
